import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Dialog } from 'primeng/dialog';

import { FileUpload } from 'primeng/fileupload';
import {
  FormularioServicoComArquivos,
  Servico,
} from 'src/app/models/Servico.model';
import { renameDefaultFilenames } from 'src/app/util/rename-default-filenames';
import { ArquivosManager } from '../../arquivos-manager';

@Component({
  selector: 'app-formulario-servico',
  templateUrl: './formulario-servico.component.html',
  styleUrls: ['./formulario-servico.component.css'],
})
export class FormularioServicoComponent
  implements OnInit, OnDestroy, OnChanges {
  @Input() loading = false;
  @Input({ required: true }) servico: Servico | undefined;
  @Input() mostrarTermoAceite = true;
  @Input() habilitarFotoIdentificacao = true;
  @Output() onEnviarFormulario = new EventEmitter<any>();
  @ViewChild('termoAceiteDialog') termoAceiteDialog?: Dialog;
  @ViewChild('arquivoDeIdentificacao') arquivoDeIdentificacao?: FileUpload;
  @ViewChild('fotoIdentificacao') fotoIdentificacao?: FileUpload;
  @ViewChild('declaracaoVeracidade') arquicoDeclaracaoVeracidade?: FileUpload;

  servicoForm!: FormGroup;
  disableTermoAceite = true;
  understandTermoAceite = false;
  //understandTermoAceite = true; // For Dev
  arquivosManager = new ArquivosManager();

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this._inicializarForm();
    this._inicializarObjetoDeArquivos();
  }

  ngOnDestroy(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.servicoForm) {
      if (this.loading) this.servicoForm.disable();
      else this.servicoForm.enable();
    }
  }

  openTermoAceite(): boolean {
    return (
      this.servico?.termoAceite !== null &&
      this.servico?.termoAceite !== undefined &&
      this.servico.termoAceite.trim().length > 0 &&
      this.mostrarTermoAceite
    );
  }

  handleShowTermoAceite(event: Event) {
    this.handleDisableTermoAceite();
    this.termoAceiteDialog?.contentViewChild?.nativeElement.addEventListener(
      'scroll',
      this.handleScrollTermoAceite.bind(this)
    );
  }

  handleScrollTermoAceite(event: Event) {
    this.handleDisableTermoAceite();
  }

  handleDisableTermoAceite() {
    let scrollTop: number =
      this.termoAceiteDialog?.contentViewChild?.nativeElement.scrollTop;
    let scrollMax: number =
      this.termoAceiteDialog?.contentViewChild?.nativeElement.scrollHeight -
      this.termoAceiteDialog?.contentViewChild?.nativeElement.clientHeight;

    if (scrollTop >= scrollMax - 10) {
      this.disableTermoAceite = false;
    }
  }

  onSubmit() {
    let formulario: FormularioServicoComArquivos = {
      informacoesServicoSolicitado: this.servicoForm.value['informacoes'],
      servicoValores: this._buscarRespostasCamposDinamicos(),
      anexos: renameDefaultFilenames(this.arquivosManager.anexos),
    };

    this.onEnviarFormulario.emit(formulario);
  }

  _buscarRespostasCamposDinamicos(): Number[] | undefined {
    return this.servico?.servicoFormulario.map((campo) =>
      Number(this.servicoForm.value[campo.id].id)
    );
  }

  _inicializarForm() {
    const grupo: any = {
      informacoes: ['', Validators.required],
    };
    this.servico?.servicoFormulario.forEach((campo) => {
      const valor =
        campo.servicoValores.length == 1 ? campo.servicoValores[0] : '';

      grupo[campo.id] = [valor, Validators.required];
    });
    this.servicoForm = this.fb.group(grupo);
  }

  _inicializarObjetoDeArquivos() {
    if (this.habilitarFotoIdentificacao && this.servico?.solicitarFotoIdentificacao) {
      this.arquivosManager.inicializarCategoriaArquivo(
        this.arquivosManager.ANEXO_FOTO_IDENTIFICACAO
      );
    }

    if (!this.mostrarTermoAceite) {
      this.arquivosManager.inicializarCategoriaArquivo(
        this.arquivosManager.DECLARACAO_VERACIDADE_ACEITE
      );
    }

    this.arquivosManager.inicializarCategoriaArquivo(
      this.arquivosManager.ANEXO_DOCUMENTO_IDENFITICACAO
    );

    this.arquivosManager.inicializarCategoriaArquivo(
      this.arquivosManager.ANEXO_DOCUMENTO_OUTROS
    );

    this.servico?.servicoAnexos.forEach((anexo) =>
      this.arquivosManager.inicializarCategoriaArquivo(anexo.nomeAnexo)
    );
  }


  isArquivosObrigatoriosSelecionados() {
    if (this.arquivoDeIdentificacao &&
      (this.arquivoDeIdentificacao?.files.length < this.arquivosManager.NUMERO_MINIMO_ARQUIVOS_IDENTIFICACAO ||
        this.arquivoDeIdentificacao?.files.length > this.arquivosManager.NUMERO_MAXIMO_ARQUIVOS_IDENTIFICACAO))
      return false;

    if (this.habilitarFotoIdentificacao && this.servico?.solicitarFotoIdentificacao && this.fotoIdentificacao?.files.length != 1)
      return false;

    if (!this.mostrarTermoAceite && this.arquicoDeclaracaoVeracidade?.files.length != 1)
      return false;

    return this.servico?.servicoAnexos
      .filter((s) => s.envioObrigatorio)
      .every((s) => this.arquivosManager.isCategoriaFilled(s.nomeAnexo));
  }
}
